module.exports = __webpack_public_path__ + "img/logoImg.f6339928.svg";